import { Typography, Autocomplete, TextField, useMediaQuery, Popover } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AdminBalanceContainer } from '../AdminBalance/AdminBalance.styled';
import { GridColDef } from '@mui/x-data-grid';
import { fetchAdminBookings, fetchTimeBlocks } from '../../api';
import { useHookState } from '../../NotificationApiHook';
import { AdminBookingsDto, IPlace } from '../../Dto';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { getRangeTime } from '../../features/Bookings/utils';
import { useAnchorElement } from '../../../hooks/useAnchorElement';
import { PopoverInfo, TimeRange } from './utils';
import {
  AdminBookingItem,
  AdminBookingsDatagrid,
  AdminBookingsInterval,
  AdminBookingsPopoverInner,
  AdminBookingsPopoverText,
} from './AdminBookings.styled';

interface AdminBookingsProps {
  placesOptions: IPlace[];
}

const AdminBookings = ({ placesOptions }: AdminBookingsProps) => {
  const showPopover = useMediaQuery('(max-width:1000px)');
  const { handleOpen, handleClose, open, anchorEl } = useAnchorElement();
  const { notificationState } = useHookState();

  const [popoverInfo, setPopoverInfo] = useState<PopoverInfo>();
  const [selectedPlaceOption, setSelectedPlaceOption] = useState<IPlace>();
  const [bookings, setBookings] = useState([]);
  const [date, setDate] = useState<Date | null>(new Date());
  const [timeRangesLoading, setTimeRangesLoading] = useState(false);
  // Мапа временных интервалов (ключ - placeId-date, значение - мапа временных интервалов)
  const [timeRangesMap, setTimeRangesMap] = useState<Map<string, TimeRange[]>>(new Map());
  //   Мапа количества столов по местам (ключ - id места, значение - количество столов)
  const [placeTablesMap, setPlaceTablesMap] = useState<Map<number, number | undefined>>(new Map());

  const onSubmit = async (placeId?: number) => {
    setTimeRangesLoading(true);
    const bookingsFromBack = (await fetchAdminBookings(
      date,
      placeId ? placeId : selectedPlaceOption?.id,
      notificationState,
    )) as AdminBookingsDto[];

    setBookings(bookingsFromBack);
    setTimeRangesLoading(false);
  };

  const fetchTimeRanges = async () => {
    if (timeRangesMap.get(`${selectedPlaceOption?.id}-${date}`)) {
      return timeRangesMap.get(`${selectedPlaceOption?.id}-${date}`);
    }

    setTimeRangesLoading(true);
    const timeBlocksFromServer = await fetchTimeBlocks(
      date,
      selectedPlaceOption?.id,
      notificationState,
    );

    // @ts-ignore
    timeRangesMap.set(`${selectedPlaceOption?.id}-${date}`, timeBlocksFromServer);
    setTimeRangesMap(new Map(timeRangesMap));
    setTimeRangesLoading(false);
  };

  useEffect(() => {
    if (date && selectedPlaceOption?.id) {
      fetchTimeRanges();
      onSubmit();
    }
  }, [date, selectedPlaceOption?.id]);

  useEffect(() => {
    if (placeTablesMap.get(selectedPlaceOption?.id)) {
      return;
    }
    const placeTablesCount = placesOptions?.find((option) => option.id === selectedPlaceOption?.id)
      ?.tables;
    setPlaceTablesMap(new Map(placeTablesMap.set(selectedPlaceOption?.id, placeTablesCount)));
  }, [selectedPlaceOption?.id]);
  console.log('placeTablesMap', placeTablesMap);
  console.log('selectedPlaceOption', selectedPlaceOption);
  const currentPlaceTablesCount = placeTablesMap.get(Number(selectedPlaceOption?.id)) || 0;

  console.log('currentPlaceTablesCount', currentPlaceTablesCount);
  console.log('timeRangesMap', timeRangesMap);
  const rows = timeRangesMap.get(`${selectedPlaceOption?.id}-${date}`)?.map((timeRange, index) => {
    const resultRow: any = {
      index,
      timeRange: timeRange,
      id: timeRange.id,
      start: getRangeTime(timeRange.start),
      end: getRangeTime(timeRange.end),
    };
    // for (let i = 1; i <= currentPlaceTablesCount; i++) {
    //   resultRow[`№-${i}`] = null;
    // }
    const bookedTimeranges = bookings.filter((booking) => booking.timerange_id === timeRange.id);
    bookedTimeranges.forEach((booking) => {
      resultRow[`№-${booking.table_number}`] = booking;
    });

    return resultRow;
  });

  const handleBookingClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    bookUserInfo?: PopoverInfo,
  ) => {
    if (bookUserInfo && showPopover) {
      handleOpen(e);
      setPopoverInfo(bookUserInfo);
    }
  };

  const sortedBookings = [...bookings].sort((a, b) => a.table_number - b.table_number);

  const columns: GridColDef[] = sortedBookings.reduce<GridColDef[]>(
    (acc, booking) => {
      // Проверяем, есть ли уже колонка с данным номером стола
      if (!acc.some((col) => col.field === `№-${booking.table_number}`)) {
        acc.push({
          field: `№-${booking.table_number}`,
          headerName: `# ${booking.table_number}`,
          flex: 1,
          renderCell: (params) => {
            const currentIndex = params.row.index;
            const nextRow = rows[currentIndex + 1];
            const prevRow = rows[currentIndex - 1];
            const name: string = params.row[`№-${booking.table_number}`]?.name;
            const username: string = params.row[`№-${booking.table_number}`]?.username;
            const differentUserNextBooking =
              nextRow &&
              nextRow[`№-${booking.table_number}`] &&
              name !== nextRow[`№-${booking.table_number}`]?.name;
            const sameUserNextBooking =
              nextRow &&
              nextRow[`№-${booking.table_number}`] &&
              name == nextRow[`№-${booking.table_number}`]?.name;
            const isFirstBookingInSequence =
              !prevRow || prevRow[`№-${booking.table_number}`]?.name !== name;
            return (
              <>
                <AdminBookingItem
                  onClick={(e) =>
                    handleBookingClick(e, name && username ? { name, username } : undefined)
                  }
                  bgColor={params.row[`№-${booking.table_number}`] ? '#5F51A6' : undefined}
                  topBorderRadius={prevRow && prevRow[`№-${booking.table_number}`]}
                  bottomBorderRadius={nextRow && nextRow[`№-${booking.table_number}`]}
                  differentUserNextBooking={differentUserNextBooking}
                >
                  {!showPopover && (
                    <>
                      {name && isFirstBookingInSequence && (
                        <AdminBookingsPopoverText>{name}</AdminBookingsPopoverText>
                      )}
                      {username && isFirstBookingInSequence && (
                        <AdminBookingsPopoverText>{username}</AdminBookingsPopoverText>
                      )}
                    </>
                  )}
                </AdminBookingItem>
              </>
            );
          },
        });
      }
      return acc;
    },
    [
      {
        field: 'interval',
        headerName: 'Время',
        width: 70,
        renderCell: (params) => (
          <AdminBookingsInterval>
            <span>{params.row.start}</span>
            <span>{params.row.end}</span>
          </AdminBookingsInterval>
        ),
      },
    ],
  );

  const handlePlaceSelection = (place: IPlace) => {
    setSelectedPlaceOption(place);
  };

  return (
    <AdminBalanceContainer sx={{ marginBottom: '40px' }}>
      <Typography
        variant='h6'
        sx={{ textAlign: 'center' }}
        gutterBottom
      >
        Информация по бронированиям
      </Typography>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center' }}>
        <Autocomplete
          disableClearable
          options={placesOptions}
          value={selectedPlaceOption}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={(e, v) => handlePlaceSelection(v)}
          sx={{ width: '270px' }}
          renderInput={(params) => (
            <TextField
              {...params}
              label='Зал'
              variant='standard'
            />
          )}
        />

        <StaticDatePicker
          defaultValue={new Date()}
          value={date}
          onChange={(newValue) => setDate(newValue)}
          slots={{
            actionBar: () => null,
            toolbar: () => null,
          }}
        />
      </div>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <AdminBookingsPopoverInner>
          {popoverInfo?.name && (
            <AdminBookingsPopoverText>{popoverInfo?.name}</AdminBookingsPopoverText>
          )}
          {popoverInfo?.username && (
            <a href={`tel:${popoverInfo?.username}`}>
              <AdminBookingsPopoverText>{popoverInfo?.username}</AdminBookingsPopoverText>
            </a>
          )}
        </AdminBookingsPopoverInner>
      </Popover>

      {selectedPlaceOption && (
        <AdminBookingsDatagrid
          getRowId={(row) => row.id}
          rows={rows}
          columns={columns}
          isRowSelectable={() => false}
          disableColumnFilter
          disableColumnSorting
          disableRowSelectionOnClick
          disableColumnMenu
          hideFooterPagination
          hideFooterSelectedRowCount
          hideFooter
          loading={timeRangesLoading}
          slots={{ pagination: () => null }}
        />
      )}
    </AdminBalanceContainer>
  );
};

export default AdminBookings;
